exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Add a rotating animation to the loading icon */\n.loading-icon[data-v-e9dfd614] {\n  width: 24px;\n  height: 24px;\n  animation: spin-e9dfd614 1s linear infinite;\n}\n@keyframes spin-e9dfd614 {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/vue-svg-inline-loader/dist/index.min.js!./resources/js/Components/shared/LoadingIcon.vue?vue&type=style&index=0&id=e9dfd614&scoped=true&lang=css
// module id = 147
// module chunks = 3 5 7 8 9